import React, { useMemo } from "react";
import { Select } from "antd";
// GENERATED ENUMS
import { Control } from "../../../flatbuffers/generated/control/control";
import { ControllerInfoContent } from "../../../flatbuffers/generated/controller-info/controller-info-content";
import { Fault } from "../../../flatbuffers/generated/fault/fault";
import { GroupControl } from "../../../flatbuffers/generated/group-control/group-control";
import { GroupSupervisoryStatus } from "../../../flatbuffers/generated/group-supervisory-status/group-supervisory-status";
import { Service } from "../../../flatbuffers/generated/service/service";
import { Status } from "../../../flatbuffers/generated/status/status";
import { Traffic } from "../../../flatbuffers/generated/traffic/traffic";
import { Usage } from "../../../flatbuffers/generated/usage/usage";
// INTERFACES
import { FbMessageRef } from "../../../interfaces/FbMessage.interface";
import { LiftType } from "../../../flatbuffers/generated/archive/lift-type";

interface Props {
  value: FbMessageRef | null;
  onChange: (ref: FbMessageRef | null) => void;
  deviceType?: LiftType | "BOTH";
  categoryFilter?: number[]; // MessageContent discriminant values to include; if empty, show all
  messageValueFilter?: Set<string>; // "messageContent:messageValue" keys; if set, only these options shown
  disabled?: boolean;
  placeholder?: string;
  allowClear?: boolean;
}

interface GroupedOptions {
  label: string;
  options: FbMessageRef[];
}

function enumToOptions(
  enumObj: Record<string, string | number>,
  prefix: string,
  encodedType: number,
  messageContent: number,
  deviceType: LiftType,
): FbMessageRef[] {
  return Object.entries(enumObj)
    .filter(([, v]) => typeof v === "number")
    .map(([key, v]) => ({
      encodedType,
      messageContent,
      messageValue: v as number,
      deviceType,
      label: `${prefix}::${key}`,
    }));
}

const optionKey = (o: FbMessageRef): string =>
  `${o.encodedType}:${o.messageContent}:${o.messageValue}:${o.deviceType}`;

// Category definitions — built once at module load
const ALL_CATEGORIES: Array<{
  label: string;
  messageContent: number;
  options: FbMessageRef[];
}> = [
  {
    label: "Status",
    messageContent: 1,
    options: enumToOptions(
      Status as unknown as Record<string, string | number>,
      "Status",
      2,
      1,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Traffic",
    messageContent: 2,
    options: enumToOptions(
      Traffic as unknown as Record<string, string | number>,
      "Traffic",
      2,
      2,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Usage",
    messageContent: 3,
    options: enumToOptions(
      Usage as unknown as Record<string, string | number>,
      "Usage",
      1,
      3,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Service",
    messageContent: 4,
    options: enumToOptions(
      Service as unknown as Record<string, string | number>,
      "Service",
      1,
      4,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Control",
    messageContent: 5,
    options: enumToOptions(
      Control as unknown as Record<string, string | number>,
      "Control",
      2,
      5,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Fault",
    messageContent: 6,
    options: enumToOptions(
      Fault as unknown as Record<string, string | number>,
      "Fault",
      2,
      6,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "GroupSupervisoryStatus",
    messageContent: 7,
    options: enumToOptions(
      GroupSupervisoryStatus as unknown as Record<string, string | number>,
      "GroupSupervisoryStatus",
      2,
      7,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "GroupControl",
    messageContent: 8,
    options: enumToOptions(
      GroupControl as unknown as Record<string, string | number>,
      "GroupControl",
      2,
      8,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "ControllerInfo",
    messageContent: 9,
    options: enumToOptions(
      ControllerInfoContent as unknown as Record<string, string | number>,
      "ControllerInfo",
      2,
      9,
      LiftType.ELEVATOR,
    ),
  },
];

export default function FlatbufferMessagePicker({
  value,
  onChange,
  deviceType = "BOTH",
  categoryFilter = undefined,
  messageValueFilter = undefined,
  disabled = undefined,
  placeholder = undefined,
  allowClear = undefined,
}: Props) {
  const groupedOptions = useMemo<GroupedOptions[]>(
    () =>
      ALL_CATEGORIES.filter((cat) => {
        // Apply categoryFilter if provided and non-empty
        if (categoryFilter && categoryFilter.length > 0) {
          if (!categoryFilter.includes(cat.messageContent)) return false;
        }
        return true;
      })
        .map((cat) => {
          // Filter options by messageValueFilter (per-message) and deviceType
          const filtered = cat.options.filter((o) => {
            if (
              messageValueFilter &&
              messageValueFilter.size > 0 &&
              !messageValueFilter.has(`${o.messageContent}:${o.messageValue}`)
            )
              return false;
            if (deviceType !== "BOTH" && o.deviceType !== deviceType) return false;
            return true;
          });
          return { label: cat.label, options: filtered };
        })
        .filter((g) => g.options.length > 0),
    [deviceType, categoryFilter, messageValueFilter],
  );

  const allOptions = useMemo(() => groupedOptions.flatMap((g) => g.options), [groupedOptions]);

  const selectValue = value ? optionKey(value) : undefined;

  return (
    <Select
      showSearch
      allowClear={allowClear}
      style={{ width: "100%" }}
      placeholder={placeholder ?? "Select LN2 message"}
      optionFilterProp="label"
      value={selectValue}
      onChange={(key: string | undefined) => {
        if (!key) {
          onChange(null);
          return;
        }
        const opt = allOptions.find((o) => optionKey(o) === key);
        if (opt) onChange(opt);
      }}
      disabled={disabled}
    >
      {groupedOptions.map((group) => (
        <Select.OptGroup key={group.label} label={group.label}>
          {group.options.map((opt) => (
            <Select.Option key={optionKey(opt)} value={optionKey(opt)} label={opt.label}>
              {opt.label}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  );
}
